import { useTrackMutation } from '@mote/api'
import { TRACK_EVENT_NAMES } from '@mote/helpers'
import { flattenDataFromResponse } from '@mote/helpers/identity'
import { identifyMaybe } from '../shared'
import { useAuth } from './useAuth'

export function useLoginSuccess() {
  const trackMutation = useTrackMutation()
  const auth = useAuth()

  async function loginSuccess(data: object, withOTL: boolean = false) {
    const flattenData = flattenDataFromResponse(data)
    await trackMutation.mutate!({
      variables: {
        event: TRACK_EVENT_NAMES.auth.loginComplete,
        withOTL: Number(withOTL)
      }
    })
    auth.updateUser(flattenData)
    identifyMaybe()
  }

  return loginSuccess
}
